import { render, staticRenderFns } from "./TempIndicationUltrasound.vue?vue&type=template&id=307edb6c&scoped=true"
import script from "./TempIndicationUltrasound.vue?vue&type=script&lang=js"
export * from "./TempIndicationUltrasound.vue?vue&type=script&lang=js"
import style0 from "./TempIndicationUltrasound.vue?vue&type=style&index=0&id=307edb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307edb6c",
  null
  
)

export default component.exports